// @flow
import type { EventContent } from "redux/api-types/EventContent";
import type { BusinessLocationRecord } from "redux/modules/createCabelasClass/records/BusinessLocationRecord";
import { isChapterLocation } from "redux/modules/businessEventScheduling/instructorLocations";
import { normalizeChapterEventType } from "redux/modules/instructorChapters/constants";

export const isContentForChapterLocation = (
  content: ?EventContent,
  location: ?BusinessLocationRecord
): boolean =>
  !!content &&
  !!location &&
  isChapterLocation(location) &&
  !!normalizeChapterEventType(content.attributes.eventType) &&
  (content.attributes.businessId == null ||
    content.attributes.businessId === location.businessId);
